import { POST, GET } from 'src/network/apiHandler';
import config from 'src/globals';
import { GENERATE_OTP, VERIFY_LOGIN, LOGOUT,
  RESET_PASSWORD_VIA_LINK, RESET_PASSWORD, ORG_DETAILS,
  FORGOT_PASSWORD, SEND_LOGIN_OTP } from './routes';
import { message } from 'antd';
import { getOrgPrettyName } from 'src/utils/utils';

const { API_BASE_URL } = config;

export const generateOTP = async (data: { contactNumber: number }) => {
  const { contactNumber } = data;
  const response = await POST(API_BASE_URL + GENERATE_OTP, { contactNumber });
  return response;
};

export const sendLoginOTP = async (data: { email: string }) => {
  const { email } = data;
  const response = await POST(API_BASE_URL + SEND_LOGIN_OTP, { email });
  return response;
};

export const verifyLogin = async (data: any) => {
  const { contactNumber, otp, email, password } = data;
  const response = await POST(API_BASE_URL + VERIFY_LOGIN, { contactNumber, otp, email, password });

  if (response.isSuccess && response.data?.accessToken) {
    // store accessToken when present
    const token = response.data.accessToken;
    const storage = window.localStorage;
    storage.setItem('authToken', token.id);
    storage.setItem('userId', response.data.vendor.id);
    if (response.data.vendorUser && response.data.vendorUser.id) {
      storage.setItem('vendorUserId', response.data.vendorUser.id);
    }
    if (response.data.vendor.name) {
      storage.setItem('vendorName', response.data.vendor.name);
    }
    if (response.data.vendor.email) {
      storage.setItem('vendorEmail', response.data.vendor.email);
    }
    const { permissions } = response.data;
    if (Array.isArray(permissions)) {
      storage.setItem('permissions', JSON.stringify(permissions));
    } else {
      storage.removeItem('permissions');
    }
  } else if (!response.isSuccess) {
    message.error(response.errorMessage);
  }

  return response;
};

export const logoutUser = async () => {
  return POST(`${API_BASE_URL}${LOGOUT}`, {});
};

export const resetPasswordViaLink = async (body) => {
  return POST(`${API_BASE_URL}${RESET_PASSWORD_VIA_LINK}`, body);
};

export const resetPassword = async (body) => {
  return POST(`${API_BASE_URL}${RESET_PASSWORD}`, body);
};

export const forgotPassword = async (body) => {
  return POST(`${API_BASE_URL}${FORGOT_PASSWORD}`, body);
};

export const getOrgDetails = async (params?: any) => {
  const { prettyName, origin } = getOrgPrettyName();
  const headers = {
    'organisation-pretty-name': prettyName,
    'organisation-url': origin,
  };
  return GET(`${API_BASE_URL}${ORG_DETAILS}`, params, null, headers);
};
